import { containsHtmlMarkup, parseRichText } from './rich-text/parse-rich-text';
import { richTextToPlainText } from './rich-text/rich-text-to-plain-text';

// Plain text comes back byte-identical — the save path diffs against this projection.
export const htmlToPlainText = (value: string): string => {
  if (!value || !containsHtmlMarkup(value)) {
    return value;
  }
  return richTextToPlainText(parseRichText(value));
};

// "Is this plain text still just a projection of that markup?" — the single question behind
// both "the description was not edited, keep it off the patch" and "the original markup is
// still a truthful rendering, so show its bold and italics". Two copies would let the read
// view show formatting that the save then silently strips.
export const isPlainTextUnchangedFromHtml = (
  plainText: string,
  html: string | null | undefined,
): boolean => plainText === htmlToPlainText(html ?? '');
